import {IAngularEvent, IController, IModule, IOnChangesObject} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Saksstatistikk, Sakstidspunkt} from "felles/tjenester/ressurser/SakRessurs";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {FavorittTjeneste} from "felles/tjenester/modulspesifikke/FavorittTjeneste";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('SakerKontroller');

require('./sakIListe.scss');

export class SakIListeKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmMoeteSakIList', {
              bindings: {
                  sak: '<',
                  sakstidspunkt: '<',
                  saksstatistikk: '<'
              },
              controller: SakIListeKontroller.forInjisering(),
              template: require('./sakIListe.html')
          })
    }

    static forInjisering() {
        return [
            FavorittTjeneste.regNavn,
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            SakIListeKontroller
        ]
    }

    constructor(private favorittTjeneste: FavorittTjeneste, private webNavigasjon: WebNavigasjon, private kontekst: Kontekst) {
    }

    sak: l.AgendaelementModell; //settes via bindings/$onChanges
    sakstidspunkt: Sakstidspunkt; //settes via bindings/$onChanges
    saksstatistikk: Saksstatistikk; //settes via bindings/$onChanges

    redigeringMulig = false;

    erFavoritt(sak: l.AgendaelementModell) {
        return this.favorittTjeneste.erFavoritt(sak);
    }

    gaaTilRedigerSak($event: IAngularEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.webNavigasjon.gåTilRedigerSak(this.sak.moete.id, this.sak.id);
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'sak', () => {
            this.redigeringMulig = this.kontekst.inneharTilgangsrolleIGruppe(l.TilgangsrolleMedlem.skrive, this.sak.eiendeGruppeId) && !this.sak.moete.laastForRedigering;
        });
    }

    // hjelpemetoder
}
